import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Route } from 'react-router';
import LoadingWheel from './LoadingWheel';


const PrivateRoute = (props) => {
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {     
            axios.get('api/auth', { withCredentials: true }).then(response => {
                setAuthorized(true);
            });

     
    }, []);
    return (
        <div>{authorized ? <Route {...props} /> : <LoadingWheel message="This tool is only available to UOW staff member. Redirecting to login page..." />}</div>
    )
}
export default PrivateRoute;

